export default __webpack_public_path__ + "static/media/Main Page.4a8170cb.png";